module.exports = __webpack_public_path__ + "static/media/custRetStandIn.7fb4b295.png";